import _ from 'lodash';
import * as util from '#packages/util';
import * as editorRefreshTPADataAfterUpgrade from '../handlers/editorRefreshTPADataAfterUpgrade';
import * as bi from '../bi/bi';
import * as tpaAlertsService from '../services/tpaAlertsService';
import type { EditorAPI } from '#packages/editorAPI';
import type { AppData, Callback } from '@wix/document-services-types';
import experiment from 'experiment';

const { premiumUtils } = util;

const TYPE = {
  BENEFITS: 'tpaPanels.packagePicker.benefitsModal',
  CYCLES: 'tpaPanels.packagePicker.cyclesModal',
  EXTERNAL: 'tpaPanels.packagePicker.externalBenefitsModal',
  PACKAGES: 'tpaPanels.packagePicker.packagePickerModal',
};

const BI_TYPE = {
  BENEFITS: 'offering',
  CYCLES: 'cycle',
  PACKAGES: 'package',
  EXTERNAL: 'external',
};

const getUpgradeUrl = function (
  editorAPI: EditorAPI,
  appData: AppData,
  vendorProductId: string,
  paymentCycle: string,
  pp_type: string,
  origin: string,
  premiumIntent: string,
) {
  const referralAdditionalInfo = `tpa_${origin}_ed_14`;
  return experiment.isOpen('se_appDefIdUpdates')
    ? editorAPI.dsRead.tpaV2.billing.getAppUpgradeUrl(
        appData.appDefinitionId,
        vendorProductId,
        paymentCycle,
        {
          referralAdditionalInfo,
          pp_type,
          premiumIntent,
        },
      )
    : // @ts-expect-error
      editorAPI.dsRead.tpa.billing.getAppUpgradeUrl(
        appData.applicationId,
        vendorProductId,
        paymentCycle,
        {
          referralAdditionalInfo,
          pp_type,
          premiumIntent,
        },
      );
};

const upgradeToPremiumAndClosePickerModal = function (
  editorAPI: EditorAPI,
  appDefinitionId: string,
  vendorProductId: string,
  paymentCycle: string,
  pp_type: string,
  origin: string,
  closePanelCallback: Callback,
  premiumIntent: string,
) {
  const isSaved =
    !editorAPI.dsRead.generalInfo.isFirstSave() &&
    !editorAPI.dsRead.generalInfo.isDraft();
  const appData = editorAPI.dsRead.tpa.app.getDataByAppDefId(appDefinitionId);
  if (!isSaved) {
    tpaAlertsService.openSaveFailedAlertForPackageBuying(editorAPI);
  } else {
    const upgradeUrl = getUpgradeUrl(
      editorAPI,
      appData,
      vendorProductId,
      paymentCycle,
      pp_type,
      origin,
      premiumIntent,
    );
    window.open(upgradeUrl);
    editorRefreshTPADataAfterUpgrade.trackAppUpgrade(
      editorAPI,
      appData.applicationId,
    );
  }

  if (_.isFunction(closePanelCallback)) {
    closePanelCallback();
  }
  editorAPI.bi.event(bi.events.CLICK_UPGRADE_IN_PP, {
    pp_type,
    pp_origin: origin,
    app_site_id: appData.instanceId,
    app_id: appData.appDefinitionId,
  });
};

const pickPickerForm = function (
  editorAPI: EditorAPI,
  marketData: AnyFixMe,
  appData: AppData,
  options: { origin?: string; premiumIntent?: string } = {},
) {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line you-dont-need-lodash-underscore/assign
  const relevantData = _.assign(
    _.pick(marketData, [
      'name',
      'appIcon',
      'colorSvgIcon',
      'packages',
      'features',
      'price',
      'upgradeBenefits',
      'upgradeTitle',
      'upgradedToYearly',
      'appDefinitionId',
    ]),
    _.pick(appData, 'vendorProductId'),
  );

  relevantData.packages = _.reject(marketData.packages, { id: 'oneTime' });
  // @ts-expect-error
  if (appData?.openPremiumPage) {
    relevantData.panelName = TYPE.EXTERNAL;
    const params = {
      appDefId: appData.appDefinitionId,
      referralAdditionalInfo: options.origin,
    };
    if (options.premiumIntent) {
      // @ts-expect-error
      params.premiumIntent = options.premiumIntent;
    }
    relevantData.upgradeUrl =
      // @ts-expect-error
      editorAPI.dsRead.tpa.billing.getSiteUpgradeUrl(params);
    return relevantData;
  }

  relevantData.panelName = TYPE.EXTERNAL;
  relevantData.externalPackages = true;
  relevantData.upgradeUrl = premiumUtils.getPremiumUrl(editorAPI, {
    appDefinitionId: appData.appDefinitionId,
    origin: 'GFPP',
  });
  return relevantData;
};

export { upgradeToPremiumAndClosePickerModal, pickPickerForm, TYPE, BI_TYPE };
